import Vue from "vue";
import LoadScript from "vue-plugin-load-script";

Vue.use(LoadScript);
